var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.274414C4.97715 0.274414 0.5 4.75157 0.5 10.2744C0.5 15.7973 4.97715 20.2744 10.5 20.2744C16.0228 20.2744 20.5 15.7973 20.5 10.2744C20.4936 4.75423 16.0202 0.280843 10.5 0.274414Z",
    fill: "#F3ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2722 7.10754L10.568 14.8484C10.432 15.0289 10.2291 15.1471 10.005 15.1766C9.78094 15.2061 9.55441 15.1442 9.37634 15.005L5.30301 11.7484C4.94356 11.4607 4.88536 10.9362 5.17301 10.5767C5.46066 10.2173 5.98523 10.1591 6.34468 10.4467L9.74134 13.1642L14.9305 6.12171C15.1007 5.86637 15.3974 5.7252 15.7029 5.75424C16.0083 5.78329 16.2731 5.97785 16.3921 6.26069C16.5111 6.54352 16.465 6.86886 16.2722 7.10754Z",
    fill: "#AA468F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.688870c940961fa09e5cbe04eec50bd9.svg";
export { ForwardRef as ReactComponent };